var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VCard',{staticClass:"py-8",attrs:{"elevation":"0"}},[_c('VGridform',{attrs:{"name":_vm.name,"config":_vm.gfTemplateConfig,"callbacks":_vm.callbacks,"dev-tools":_vm.devTools}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }